/*
 * @Author: shiaiduo 1424688240@qq.com
 * @Date: 2025-11-12 08:53:11
 * @LastEditors: shiaiduo 1424688240@qq.com
 * @LastEditTime: 2025-12-12 16:49:23
 * @FilePath: \shopify_klaiyi\assets\aiTryOn.js
 * @Description:  试戴逻辑
 */
/* dataLayer 安全推送：避免推到本地空数组导致埋点丢失 */
if (typeof window.klaiyiDlPush !== "function") {
  window.klaiyiDlPush = function () {
    if (!window.dataLayer || typeof window.dataLayer.push !== "function") {
      window.dataLayer = [];
    }
    try {
      return window.dataLayer.push.apply(window.dataLayer, arguments);
    } catch (err) {
      return 0;
    }
  };
}
var $ = jQuery;
let swiperRealIndex = 0;
let thumbBannerSwiper = null;
let BannerSwiper = null;
let isShake = false;
let isShowPhoneBtn = true;
let isShowVideo = false;
let formState = {
  files: [],
};
let webPromise = null; //视频流
let isFrontCamera = true;
let imageOriginalName = ""; //原图
let isClickCapture = false;
let photoURL = null;
let photoURLCopy = null;
let isValidataImg = null;
let tryToken = null;
let ws = null;
let isWsInit = false;
let constraintsVal = null;
let homeImgSrc = "";
let isShowCompareImg = false;
let styleModel = null;
let compareImgData = [
  {
    image: "",
    width: "",
    height: "",
    title: "CompareView",
    isOriginalImg: false,
  },
  {
    image: "",
    width: "",
    height: "",
    title: "CompareView",
    isOriginalImg: false,
  },
  {
    image: "",
    width: "",
    height: "",
    title: "CompareView",
    isOriginalImg: false,
  },
  {
    image: "",
    width: "",
    height: "",
    title: "CompareView",
    isOriginalImg: false,
  },
];
let dataImgWidth = 0;
let dataImgHeight = 0;
let upImgVal = "";
let compareImgLenth = 0;
let isClickSaveAlbum = false;
let compareImgVal = null;
let isLogin = window.customerData.email;
let tryOnInfo = null;
let campaignBanner = null;
let starnum = 5;
let checkedData = "";
let reviewTextarea = "";
let loginPopupEnabled = true; //登录验证
let popupEnabled = false; //授权验证
let tryOnData = null;
let isAuthorized = false;
let appDownLoadLinkEnabled = false;
let dataImgWidthOriginal = 0;
let dataImgHeightOriginal = 0;
let shareTryOnInfo = null;
let isShowAbility = false;
let isShowCoupon = false;
let errorLinkNumber = 6;
let customerTryOnNumber = 3;
let swiperIndex = 0;
let timeSecond = 10;
let timeInt = null;
let productItem = null;
let recommendPro = null;
let fileChangeStartSource = "";
let commentPopTag = null;
let imgLoadFlag = false;
/** 试戴结果缓存：同原图 + 同模型再次切换可直接出图，利于 INP */
let tryOnResultCache = Object.create(null);
const TRYON_COMPRESS_MAX_SIDE = 1600;
const TRYON_COMPRESS_QUALITY = 0.82;
const TRYON_COMPRESS_SKIP_BYTES = 400 * 1024;

function getTryOnCacheKey(styleId) {
  return String(imageOriginalName || "") + "::" + String(styleId || "");
}

function clearTryOnResultCache() {
  tryOnResultCache = Object.create(null);
}

/** 先让浏览器完成 loading 绘制，再跑重任务，避免拖高 INP */
function yieldToNextPaint() {
  return new Promise(function (resolve) {
    if (typeof requestAnimationFrame !== "function") {
      setTimeout(resolve, 0);
      return;
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(resolve);
    });
  });
}

/**
 * 上传前压缩：限制最长边并转 JPEG，显著缩短上传等待
 */
function compressImageFile(file, maxSide, quality) {
  maxSide = maxSide || TRYON_COMPRESS_MAX_SIDE;
  quality = quality || TRYON_COMPRESS_QUALITY;
  if (!file || !file.type || file.type.indexOf("image/") !== 0) {
    return Promise.resolve(file);
  }
  if (file.type === "image/gif" || file.type === "image/svg+xml") {
    return Promise.resolve(file);
  }
  return new Promise(function (resolve) {
    var objectUrl = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      URL.revokeObjectURL(objectUrl);
      var w = img.naturalWidth || img.width;
      var h = img.naturalHeight || img.height;
      if (!w || !h) {
        resolve(file);
        return;
      }
      var scale = Math.min(1, maxSide / Math.max(w, h));
      if (scale >= 1 && file.size <= TRYON_COMPRESS_SKIP_BYTES) {
        resolve(file);
        return;
      }
      var tw = Math.max(1, Math.round(w * scale));
      var th = Math.max(1, Math.round(h * scale));
      var canvas = document.createElement("canvas");
      canvas.width = tw;
      canvas.height = th;
      var ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(file);
        return;
      }
      ctx.drawImage(img, 0, 0, tw, th);
      canvas.toBlob(
        function (blob) {
          if (!blob || blob.size >= file.size) {
            resolve(file);
            return;
          }
          var baseName = (file.name || "tryon.jpg").replace(/\.\w+$/, ".jpg");
          resolve(
            new File([blob], baseName, {
              type: "image/jpeg",
              lastModified: Date.now(),
            })
          );
        },
        "image/jpeg",
        quality
      );
    };
    img.onerror = function () {
      URL.revokeObjectURL(objectUrl);
      resolve(file);
    };
    img.src = objectUrl;
  });
}

/** canvas 导出为压缩后的 JPEG File（拍照/拼图共用） */
function canvasToTryOnFile(canvas, fileName) {
  return new Promise(function (resolve) {
    if (!canvas) {
      resolve(null);
      return;
    }
    var w = canvas.width;
    var h = canvas.height;
    var scale = Math.min(1, TRYON_COMPRESS_MAX_SIDE / Math.max(w, h || 1));
    var out = canvas;
    if (scale < 1) {
      out = document.createElement("canvas");
      out.width = Math.max(1, Math.round(w * scale));
      out.height = Math.max(1, Math.round(h * scale));
      var ctx = out.getContext("2d");
      if (!ctx) {
        resolve(null);
        return;
      }
      ctx.drawImage(canvas, 0, 0, out.width, out.height);
    }
    out.toBlob(
      function (blob) {
        if (!blob) {
          resolve(null);
          return;
        }
        resolve(
          new File([blob], fileName || Date.now() + ".jpg", {
            type: "image/jpeg",
            lastModified: Date.now(),
          })
        );
      },
      "image/jpeg",
      TRYON_COMPRESS_QUALITY
    );
  });
}

function applyCachedTryOnResult(cached, item, index) {
  upImgVal = cached.image;
  if (cached.share_link) {
    shareLink = cached.share_link;
  }
  recommendPro = item;
  isValidataImg = true;
  thumbStatus = true;
  swiperIndex = index;
  swiperRealIndex = index;
  dataImgWidth = cached.width;
  dataImgHeight = cached.height;
  $(".ability").removeClass("hide");
  imgRadio();
  updataCompareImg();
  showHomeContent();
  $(".tryAi-loading").hide();
}

//
function productGaBrower(productItem) {
  console.log("试戴03", productItem);
  window.klaiyiDlPush({
    event: "dle_view_item_list",
    dlv_ec: "ai-try-on",
    dlv_ea: `productView`,
    dlv_el: "ai-try-on_productList",
    dlv_en: "view_item_list",
    ecommerce: {
      items: [
        {
          item_name: productItem?.title,
          item_id: productItem?.product_id,
          price: productItem?.price_new,
          item_category:
            productItem?.categories && productItem?.categories?.length > 0
              ? productItem.categories[0]?.id
              : 0,
          item_list_name: "ai-try-on_productList",
          index: 1,
          quantity: 1,
          currency: "$",
        },
      ],
    },
  });
}
/**
 * @Date: 2024-08-27 14:25:04
 * @Description: Do not Description
 * @param {*} callback
 * @param {*} options user-blocking， user-visible，background
 * @return {*} 任务拆解
 */
function scheduleTask(callback, options = "user-visible") {
  // 检查是否在浏览器环境中
  if (typeof window !== "undefined") {
    // eslint-disable-next-line no-undef
    if (
      typeof scheduler !== "undefined" &&
      typeof scheduler.postTask === "function"
    ) {
      // 使用 Scheduler.postTask
      // eslint-disable-next-line no-undef
      scheduler.postTask(callback, { priority: options });
    } else {
      // 使用 setTimeout 作为最后的回退
      let time = setTimeout(() => {
        callback();
        clearTimeout(time);
      }, 0);
    }
  } else {
    // 在非浏览器环境中直接调用回调
    callback();
  }
}
// 设置LocalStorage 及过期时间
function setLocalStorage(key, value, day = 1) {
  // 设置过期原则
  if (!value) {
    localStorage.removeItem(key);
  } else {
    const exp = new Date();
    if (Array.isArray(value)) {
      localStorage[key] = JSON.stringify({
        value,
        expires: exp.getTime() + day * 24 * 60 * 60 * 1000,
      });
    } else {
      localStorage[key] = JSON.stringify({
        value,
        expires: exp.getTime() + day * 24 * 60 * 60 * 1000,
      });
    }
  }
}

// 获取LocalStorage过期时间
function getLocalStorage(key) {
  try {
    const o = JSON.parse(localStorage[key]);
    if (!o || o.expires < Date.now()) {
      return false;
    } else {
      return o.value;
    }
  } catch (e) {
    if (localStorage.getItem(key) === null) {
      return undefined;
    } else {
      return localStorage[key];
    }
  }
}
function toast(toastInfo) {
  let text,
    time = 5000,
    iconName,
    iconUseTag;
  if (typeof toastInfo === "string") {
    text = toastInfo;
  } else if (typeof toastInfo === "object") {
    switch (toastInfo.type) {
      case "success":
        iconName =
          "https://cdn.shopify.com/s/files/1/1720/3725/files/icon-a-CheckCircle2.svg?v=1763026167";
        break;
      case "fail":
        iconName =
          "https://cdn.shopify.com/s/files/1/1720/3725/files/icon-a-CloseCircle1.svg?v=1763026167";
        break;
      case "warning":
        iconName = "icon-a-DangerCircle1";
        break;
      default:
        iconName =
          "https://cdn.shopify.com/s/files/1/1720/3725/files/icon-a-CheckCircle2.svg?v=1763026167";
        break;
    }
    text = toastInfo.content;
    // iconName = toastInfo.iconName;
    iconUseTag = toastInfo.iconUseTag || "i"; // 使用的标签 svg 或者 i。 默认使用svg
    time = toastInfo.time || 2000;
  }
  // { text = "要显示的内容", time = 2000, type = undefined } = {}

  const toastComponent = $(` <div  class="flex flex-centerXY toast-container">
        <div class="toast-content flex-centerXY">
       ${iconName ? "<p class='icon-tip'><img src=" + iconName + "/></p>" : ""}
        <p class="text"> ${text}</p>
        </div>
     </div>`);

  // 插入到body
  $(".try-on").append(toastComponent);
  $(".toast-container .toast-content").addClass("active");
  // 回调函数
  let times = setTimeout(function () {
    clearTimeout(times);
    toastComponent.fadeOut(300, function () {
      $(this).remove();
      $(".toast-container .toast-content").removeClass("active");
    });
  }, time);
}
function tryOnDataCallBack(val) {
  styleModel = val?.style_model;
  let bannerHtml = "";
  let thumbHtml = "";
  shareTryOnInfo = val?.customer?.share_try_on_info;
  lastTryOnInfo = val?.customer?.last_try_on_info;
  isShowAbility = shareTryOnInfo?.id || lastTryOnInfo?.id ? true : false;
  isShowCoupon = val?.customer?.is_show_coupon;
  if (val?.customer) {
    customerTryOnNumber = val?.customer?.customer_try_on_number;
  }

  styleModel.forEach(function (value, indexs) {
    bannerHtml =
      bannerHtml +
      "<div class='swiper-slide'>  <img class='aiBox-top_banner swiper-lazy' src='https://cdn.shopify.com/s/files/1/1720/3725/files/800-800_dce63f16-5121-4242-8106-8369869d59cf.jpg?v=1703750457' data-src='" +
      window.API_BASE +
      "/uploads/" +
      value?.style_image +
      "'> </div>";
    thumbHtml =
      thumbHtml +
      "<div class='swiper-slide thumbBanner-item" +
      (value?.show_hot ? " isHot" : "") +
      "' data-index='" +
      indexs +
      "'> <img class='thumbBanner-img' src='" +
      window.API_BASE +
      "/uploads/" +
      value?.style_model_image +
      "'><div class='flex thumbBanner-nameBox'><p class='thumbBanner-name line2'>" +
      value?.title +
      "</p> </div> </div>";
  });

  $(".banner .swiper-wrapper").html(bannerHtml);
  $(".thumbBanner .swiper-wrapper").html(thumbHtml);
  scheduleTask(function () {
    initBanner();

    if (lastTryOnInfo) {
      photoURL = lastTryOnInfo?.source_image;
      upImgVal = lastTryOnInfo?.last_success_image;
      imageOriginalName = lastTryOnInfo?.image_original_name;
      isValidataImg = true;
      isShowPhoneBtn = false;
      photoURLCopy = lastTryOnInfo?.source_image;

      styleModel?.forEach((item, index) => {
        if (item?.name == lastTryOnInfo?.style_id) {
          recommendPro = item;
          // initBanner() 已初始化双 Swiper，勿再 destroy 缩略图（会导致 Banner thumbs 悬空 → cssMode 报错）
          let time = setTimeout(function () {
            swiperRealIndex = index;
            safeSwiperSlideTo(BannerSwiper, index);
            safeSwiperSlideTo(thumbBannerSwiper, index);
            clearTimeout(time);
          }, 500);
        }
      });
      showHomeContent();
      productGaBrower(recommendPro.product);
      dataImgWidth = lastTryOnInfo?.width;
      dataImgHeight = lastTryOnInfo?.height;
      imgRadio();
    } else if (shareTryOnInfo) {
      photoURL = shareTryOnInfo?.source_image;
      upImgVal = shareTryOnInfo?.try_on_image;
      imageOriginalName = shareTryOnInfo?.image_original_name;
      photoURLCopy = shareTryOnInfo?.source_image;
      isValidataImg = true;
      isShowPhoneBtn = false;

      styleModel?.forEach((item, index) => {
        if (item?.name == shareTryOnInfo?.style_id) {
          recommendPro = item;
          let time = setTimeout(function () {
            swiperRealIndex = index;
            safeSwiperSlideTo(BannerSwiper, index);
            safeSwiperSlideTo(thumbBannerSwiper, index);
            clearTimeout(time);
          }, 500);
        }
      });

      showHomeContent();
      productGaBrower(recommendPro.product);
    }

    $(".thumbBanner-item").on("click", function (event) {
      let clickIndex = $(this).attr("data-index");
      tryOnModule(styleModel[clickIndex], clickIndex);
      $(".thumbBanner-item.swiper-slide-thumb-active").removeClass(
        "swiper-slide-thumb-active"
      );
      $(this).addClass("swiper-slide-thumb-active");
    });
    if (isShowCoupon) {
      showCoupon();
    }
  });
  // 是否需要校验登录  +  授权
  loginPopupEnabled = val?.login_popup_enabled;
  popupEnabled = val?.popup_enabled;
  isAuthorized = val?.customer?.is_authorized;
  scheduleTask(function () {
    $(".upPhone-cover").on("click", function () {
      if (!isLogin && loginPopupEnabled) {
        $("#loginModal").fadeIn();
        return false;
      }
      if (popupEnabled && !isAuthorized) {
        //
        $(".tryOnDialog .pop_title_left").text(val?.authorization_popup_title);
        $(".tryOnDialog-con").html(
          '<img src="' +
            window.API_BASE +
            "/uploads/" +
            val?.specification_popup +
            '" alt="tryOnDialog"  widdth="390" height="470">'
        );
        scheduleTask(() => {
          openPop(".tryOnDialog");
          comfirmTryOnDialog();
        });
      }
    });
  });

  //同意条约
  if (
    !isAuthorized &&
    getLocalStorage("authorizeResult") != "authorizeResult"
  ) {
    comfirmTryOnDialog();
  }
  // 其他地方授权
  if (
    !isAuthorized &&
    popupEnabled &&
    getLocalStorage("authorizeResult") == "authorizeResult"
  ) {
    authorization();
  }
  coverLogin(val);
}
function tyOnDataInit() {
  console.log("获取未登录的001 uuid");
  let uuidVal = "";
  if (!window.customerData?.email) {
    uuidVal = window.ShopifyCustomerInfo?.uuid || "";
    if (uuidVal) setLocalStorage("uuid", uuidVal, 24 * 30 * 6);
  }
  console.log(
    "获取未登录的uuid",
    window.customerData?.id,
    window.ShopifyCustomerInfo?.uuid
  );
  const url = window.location.href; // 获取当前页面 URL
  const params = new URLSearchParams(new URL(url).search); // 解析参数部分
  const tryOnShareToken = params.get("tryOnShareToken"); // 获取 proId 的值
  if (tryOnShareToken) {
    customerVal = tryOnShareToken;
  }
  console.log("接口01", getLocalStorage("uuid"), uuidVal);
  $.ajax({
    url: window.API_BASE + "/api/klaiyi/try_on/index",
    type: "GET",
    headers: {
      Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
      "Content-Type": "application/json",
    },
    data: {
      tryOnShareToken: tryOnShareToken,
      customer_id: isLogin
        ? window.customerData?.id
        : getLocalStorage("uuid") || uuidVal,
    },
    success: function (res) {
      if (res?.code == 200000) {
        tryOnData = res?.data;
        appDownLoadLinkEnabled = tryOnData?.app_down_load_link_enabled - 0;
        commentPopTag = tryOnData?.comment_pop_tag;
        tryOnDataCallBack(res?.data);
        scheduleTask(function () {
          $(".tryOnCode-copy-imgBox").css({
            paddingBottom:
              (tryOnData?.coupon_popup_image_height /
                tryOnData?.coupon_popup_image_width) *
                100 +
              "%",
          });
        });
      }
    },
    error: function () {
      toast("Error adding address");
    },
  });
}
/** 安全销毁 Swiper，避免 destroy 后仍被 thumbs / slideTo 访问 params.cssMode */
function destroySwiperInstance(instance) {
  if (instance && !instance.destroyed && typeof instance.destroy === "function") {
    try {
      instance.destroy(true, true);
    } catch (err) {}
  }
  return null;
}

function safeSwiperSlideTo(instance, index, speed) {
  if (
    !instance ||
    instance.destroyed ||
    typeof instance.slideTo !== "function" ||
    !instance.params
  ) {
    return;
  }
  try {
    if (instance.params.loop && typeof instance.slideToLoop === "function") {
      instance.slideToLoop(index, speed);
    } else {
      instance.slideTo(index, speed);
    }
  } catch (err) {}
}

// 小图初始化
function initSwiper() {
  thumbBannerSwiper = destroySwiperInstance(thumbBannerSwiper);
  if (typeof Swiper !== "function" || !document.querySelector(".thumbBanner")) {
    return;
  }
  thumbBannerSwiper = new Swiper(".thumbBanner", {
    spaceBetween: 6,
    slidesPerView: "auto",
    slidesPerGroup: 1,
    freeMode: true,
    observer: true,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
  });
}
// banner初始化
function initBanner() {
  initSwiper();
  BannerSwiper = destroySwiperInstance(BannerSwiper);
  if (
    typeof Swiper !== "function" ||
    !document.querySelector(".banner") ||
    !thumbBannerSwiper ||
    thumbBannerSwiper.destroyed
  ) {
    return;
  }
  BannerSwiper = new Swiper(".banner", {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    autoplay: true,
    slidesPerGroup: 1,
    watchSlidesVisibility: true,
    observer: true,
    observerParents: true,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    thumbs: {
      swiper: thumbBannerSwiper,
    },
    on: {
      slideChange: function () {
        swiperRealIndex = this.realIndex;
      },
    },
  });
}
function shakeModule() {
  if (getLocalStorage("shakeAnimate") == "shakeAnimate") {
    return false;
  }
  setLocalStorage("shakeAnimate", "shakeAnimate", 30 / 24);
  isShake = true;
  $("#swipe").removeClass("hide").addClass("shake");
  const element = document.getElementById("swipe");
  element?.addEventListener("animationend", () => {
    element.classList.remove("shake");
    element.classList.add("fade-out");
  });
  window.dleCustomEvent("aiTryOn_icon", "AiTryOn_swipe", "view", "ai-try-on");
}

//上传图
function handlerFileChange(el, type) {
  $(el).on("change", function (event) {
    fileChangeStartSource = type;
    const files = event.target.files;
    if (files.length === 0) {
      return false;
    }
    // 立刻出 loading，缩短 Interaction → Next Paint
    $(".tryAi-loading").show();
    scheduleTask(function () {
      hanleFiles(files[0]);
    });
  });
  $(el).on("click", function () {
    window.scheduleTask(function () {
      if (type == "upload") {
        window.dleCustomEvent(
          "aiTryOn_icon",
          "AiTryOn_Upload from album",
          "click",
          "ai-try-on"
        );
      } else if (type == "uploads") {
        window.dleCustomEvent(
          "aiTryOn_icon",
          "AiTryOn_Change",
          "click",
          "ai-try-on"
        );
      }
    });
  });
}
async function hanleFiles(files) {
  $(".tryAi-loading").show();
  clearTryOnResultCache();
  await yieldToNextPaint();
  try {
    var uploadFile = await compressImageFile(files);
    let formDatas = new FormData();
    formDatas.append("file", uploadFile);
    formDatas.append("type", "image");
    formDatas.append("mod", "tryon");
    $.ajax({
      url: window.API_BASE + "/api/common/upload",
      type: "POST",
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
      },
      data: formDatas,
      processData: false, // 核心：禁止 jQuery 处理 FormData
      contentType: false, // 核心：让浏览器自动设置 Content-Type
      dataType: "json",
      success: function (result) {
        formState.files = [];
        if (result?.code == 200000) {
          dataImgWidthOriginal = result?.data?.width - 0;
          dataImgHeightOriginal = result?.data?.height - 0;
          imageOriginalName = result?.data?.url;
          getFile(result?.data);
          if (fileChangeStartSource == "video") {
            isShowVideo = false;
            showHomeContent();
          }
        } else {
          $(".tryAi-loading").hide();
        }
      },
      error: function () {
        if (fileChangeStartSource == "video") {
          isShowVideo = false;
          showHomeContent();
        }
        formState.files = [];
        $(".tryAi-loading").hide();
      },
    });
  } catch (error) {
    $(".tryAi-loading").hide();
    throw new Error("upload失败" + error);
  }
}
// 上传原图
async function getFile(res) {
  photoURL = res.url;
  isClickCapture = false;
  // 此处上传图片校验
  await tryOnCheck(photoURL);
}
async function tryOnCheck(data) {
  if (!tryToken) {
    // token未生成 请稍后再试
    $(".tryAi-loading").hide();
    toast("Establishing Data Link... ");
    return false;
  }
  try {
    // 连接成功，可以安全地发送消息
    ws?.send(
      JSON.stringify({
        type: "detect_image",
        url:
          data.indexOf("https://cdn.aistyle.me") > -1 ||
          data.indexOf(".klaiyihair.com") > -1
            ? data
            : "https://ima.klaiyihair.com/" + data,
        style_id: "", //非必传没选就不传
        token: tryToken,
        image_original_name: imageOriginalName,
      })
    );
  } catch (error) {
    throw new Error("图片监测接口报错" + error);
  }
}
async function startVideo() {
  if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
  }
  let deviceW = window.innerWidth;
  // let deviceH = (window.innerWidth * 487) / 390;
  const constraints = {
    video: {
      // 在移动设备上面，表示优先使用前置摄像头
      facingMode: isFrontCamera ? "user" : "environment",
      // 判断是否是移动端 PC端为640*640
      // width: deviceW,
      // height: deviceW,
    },
    audio: false,
    advanced: [
      {
        width: (deviceW * 487) / 390,
        height: deviceW,
      },
      {
        aspectRatio: 390 / 487,
      },
    ],
  };
  constraintsVal = constraints;
  if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
  }
  if (navigator.mediaDevices.getUserMedia === undefined) {
    navigator.mediaDevices.getUserMedia = function (constraints) {
      // 首先，如果有getUserMedia的话，就获得它
      var getUserMedia =
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;

      // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
      if (!getUserMedia) {
        return Promise.reject(
          new Error("getUserMedia is not implemented in this browser")
        );
      }

      // 否则，为老的navigator.getUserMedia方法包裹一个Promise
      return new Promise(function (resolve, reject) {
        getUserMedia.call(navigator, constraints, resolve, reject);
      });
    };
  }
  let stream = await navigator.mediaDevices.getUserMedia(constraints);
  this.webPromise = stream;
  let v = document.getElementById("aiBox-video_val");
  try {
    if (stream) {
      if ("srcObject" in v) {
        v.srcObject = stream;
      } else {
        // 防止再新的浏览器里使用它，应为它已经不再支持了
        v.src = window.URL.createObjectURL(stream);
      }
      // v.onloadedmetadata = function (e) {
      //   v.play();
      // };
    }
  } catch (error) {
    throw new Error();
  }
}
// 开始拍照
function initVideo() {
  let video = document.getElementById("aiBox-video_val");
  video.width = video.clientWidth;
  video.height = (video.clientWidth * 487) / 390;
  video.play();
}
// 结束拍照
function stopVideo() {
  let video = document.getElementById("aiBox-video_val");
  video?.pause();
  const stream = video?.srcObject;
  if (stream) {
    stream.getTracks().forEach((track) => track.stop()); // 停止所有轨道
  }
  // 从 DOM 中移除视频元素
  video.srcObject = null; // 释放视频流
}
// 相机反转
async function cameraRotate() {
  isFrontCamera = !isFrontCamera;
  if (isFrontCamera) {
    $("#aiBox-video_val").addClass("frontCamera");
  } else {
    $("#aiBox-video_val").removeClass("frontCamera");
  }
  await startVideo();
  initVideo();
}
// 流转图片
async function blobToImage(isVideo) {
  imgLoadFlag = false;
  let video = document.getElementById(
    isVideo ? "aiBox-video_val" : "aiBox-compare"
  );
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  // 设置 canvas 尺寸
  let loadImgLength = 0;
  if (isVideo) {
    canvas.width = video.videoWidth ? video.videoWidth : video.clientWidth;
    canvas.height = video.videoHeight ? video.videoHeight : video.clientHeight;
    loadImgLength = 1;
  } else {
    const images = video.querySelectorAll("img");
    let imgLength = 0;

    images.forEach(function (itemsImg) {
      if (
        itemsImg?.src &&
        itemsImg?.src?.indexOf("https://www.klaiyihair.com/pages/ai-try-on") ==
          -1
      ) {
        loadImgLength++;
      }
    });

    if (
      images[0].src &&
      images[1].src &&
      images[2].src.indexOf("https://www.klaiyihair.com/pages/ai-try-on") >
        -1 &&
      images[3].src.indexOf("https://www.klaiyihair.com/pages/ai-try-on") > -1
    ) {
      imgLength = 2;
    }

    canvas.width = video.videoWidth
      ? video.videoWidth * 2
      : video.clientWidth * 2;
    canvas.height = video.videoHeight
      ? video.videoHeight * 2
      : video.clientHeight * (imgLength == 2 ? 1 : 2);
  }

  if (isFrontCamera && isVideo) {
    ctx.translate(canvas.width, 0);
    ctx.scale(-1, 1);
  } else {
    ctx.save();
    ctx.scale(1, 1);
    ctx.restore();
  }
  let loadImg = 0;
  if (!isVideo) {
    const images = video.querySelectorAll("img");
    let imgLength = images?.length;
    for (let i = 0; i < imgLength; i++) {
      // await new Promise((resolve) => {
      if (images[i].src) {
        const rect = images[i].getBoundingClientRect();
        const parentRect = video.getBoundingClientRect();
        const x = rect.left - parentRect.left; // 相对父元素坐标
        const y = rect.top - parentRect.top;
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = images[i].src;
        img.onload = await function () {
          ctx.drawImage(
            img,
            imgLength == 1 ? 0 : x * 2,
            y * 2,
            //
            imgLength == 1 ? parentRect.width * 2 : rect.width * 2,
            imgLength == 1 ? parentRect.height * 2 : rect.height * 2
          ); // 按原位置绘制:ml-citation{ref="10" data="citationList"}
          loadImg++;
          // resolve();
        };
      }

      // });
    }
  } else {
    loadImg = 1;
    // 将图片绘制到 canvas
    try {
      video?.pause();
      await ctx.drawImage(video, 0, 0);
    } catch (error) {
      //eslint-disable-next-line no-console
      console.error("Error drawing video to canvas:", error);
    }
  }
  let exportStarted = false;
  let times = setInterval(async () => {
    if (loadImg != loadImgLength || exportStarted) {
      return false;
    }
    exportStarted = true;
    clearInterval(times);
    await yieldToNextPaint();
    try {
      const file = await canvasToTryOnFile(canvas, Date.now() + ".jpg");
      if (!file) {
        $(".tryAi-loading").hide();
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "image");
      formData.append("mod", "tryon");

      if (isVideo) {
        clearTryOnResultCache();
        try {
          $(".tryAi-loading").show();
          $.ajax({
            url: window.API_BASE + "/api/common/upload",
            type: "POST",
            headers: {
              Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
            },
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function (res) {
              if (res?.code == 200000) {
                photoURL = res?.data?.url;
                if (res?.data?.url) {
                  imageOriginalName = res.data.url;
                }
                if (res?.data?.width) {
                  dataImgWidthOriginal = res.data.width - 0;
                }
                if (res?.data?.height) {
                  dataImgHeightOriginal = res.data.height - 0;
                }
                scheduleTask(async () => {
                  isClickCapture = true;
                  await tryOnCheck(photoURL);
                  stopVideo();
                  isShowVideo = false;
                  $(".aiBox-capture").addClass("aiBox-capture--hide");
                  imgLoadFlag = true;
                });
              } else {
                $(".tryAi-loading").hide();
              }
            },
            error: function () {
              $(".tryAi-loading").hide();
            },
          });
        } catch (error) {
          $(".tryAi-loading").hide();
          throw new Error("视频上传拍照报错" + error);
        }
      } else {
        try {
          $.ajax({
            url: window.API_BASE + "/api/common/upload",
            type: "POST",
            headers: {
              Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
            },
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function (res) {
              compareImgVal = res?.data?.url;
              imgLoadFlag = true;
            },
            error: function () {},
          });
        } catch (error) {
          throw new Error("视频上传拍照报错" + error);
        }
      }
    } catch (error) {
      $(".tryAi-loading").hide();
      exportStarted = false;
    }
  }, 50);

  // };
}
// 拍照
async function takePictures() {
  try {
    $(".tryAi-loading").show();
    blobToImage(true);
  } catch (error) {
    throw new Error("Error taking photo: ", error);
  }
}
// 清除对比的某一张图
function clearCompare(index) {
  compareImgData[index].image = "";
  compareImgData.forEach(function (value, indexs) {
    if (value?.image) {
      $(".aiBox-compare .aiBox-compare-item")
        .eq(indexs)
        .find("img")
        .attr("src", value?.image);
      $(".aiBox-compare .aiBox-compare-item")
        .eq(index)
        .find(".aiBox-compare-close")
        .show();
    } else {
      $(".aiBox-compare .aiBox-compare-item")
        .eq(indexs)
        .find("img")
        .attr("src", "");
      $(".aiBox-compare .aiBox-compare-item")
        .eq(index)
        .find(".aiBox-compare-close")
        .hide();
    }
  });
}
/**
 * @Date: 2025-07-11 17:42:48
 * @Description:  对比图片方法
 * @return {*}
 */
function imgCampare() {
  isShowCompareImg = !isShowCompareImg;
  if (isShowCompareImg) {
    $("#aiBox-compare").removeClass("hide");
  } else {
    $("#aiBox-compare").addClass("hide");
  }
  $(".ability-svg--compare").attr(
    "src",
    isShowCompareImg
      ? "https://cdn.shopify.com/s/files/1/1720/3725/files/campare2.svg?v=1762911590"
      : "https://cdn.shopify.com/s/files/1/1720/3725/files/campare1.svg?v=1762911590"
  );

  if (isShowCompareImg) {
    compareImgData = [
      {
        image: "",
        width: "",
        height: "",
        title: "CompareView",
        isOriginalImg: false,
      },
      {
        image: "",
        width: "",
        height: "",
        title: "CompareView",
        isOriginalImg: false,
      },
      {
        image: "",
        width: "",
        height: "",
        title: "CompareView",
        isOriginalImg: false,
      },
      {
        image: "",
        width: "",
        height: "",
        title: "CompareView",
        isOriginalImg: false,
      },
    ];
    compareImgData[0].image = homeImgSrc;
    compareImgData[0].width = JSON.parse(JSON.stringify(dataImgWidth));
    compareImgData[0].height = JSON.parse(JSON.stringify(dataImgHeight));
    if (upImgVal) {
      // 对比图
      compareImgData[0].isOriginalImg = false;
      compareImgData[1].image = photoURLCopy ? photoURLCopy : photoURL;
      compareImgData[1].width = JSON.parse(JSON.stringify(dataImgWidth));
      compareImgData[1].height = JSON.parse(JSON.stringify(dataImgHeight));
      compareImgData[1].isOriginalImg = true;
    } else {
      compareImgData[0].isOriginalImg = true;
    }
    compareImgData.forEach(function (value, indexs) {
      if (value?.image) {
        $(".aiBox-compare .aiBox-compare-item")
          .eq(indexs)
          .find("img")
          .attr("src", value?.image);
        $(".aiBox-compare .aiBox-compare-item")
          .eq(indexs)
          .find(".aiBox-compare-close")
          .show();
      } else {
        $(".aiBox-compare .aiBox-compare-item")
          .eq(indexs)
          .find(".aiBox-compare-close")
          .hide();
        $(".aiBox-compare .aiBox-compare-item")
          .eq(indexs)
          .find("img")
          .attr("src", "");
      }
      if (
        value?.width &&
        value?.height &&
        value?.width / value?.height > 194 / (boxImgHeight / 2)
      ) {
        $(".aiBox-compare .aiBox-compare-item")
          .eq(indexs)
          .find("img")
          .addClass("aiBox-compare-item-img--width")
          .removeClass("aiBox-compare-item-img--height");
      } else {
        $(".aiBox-compare .aiBox-compare-item")
          .eq(indexs)
          .find("img")
          .addClass("aiBox-compare-item-img--height")
          .removeClass("aiBox-compare-item-img--width");
      }
    });
  }
}
//下载图片
// 下载图片弹窗
async function saveAlbum() {
  compareImgLenth = compareImgData?.filter((item) => {
    return item?.image;
  })?.length;
  if (isShowCompareImg && compareImgLenth != 1) {
    isClickSaveAlbum = true;
    await this.blobToImage(false);
  } else {
    if (!upImgVal) {
      toast({
        type: "fail",
        content: "Please select the model to try on first!",
      });
      return false;
    }
  }

  scheduleTask(async function () {
    let timeInt = setInterval(async function () {
      if (imgLoadFlag) {
        clearInterval(timeInt);
      } else if (isClickSaveAlbum) {
        return false;
      } else {
        clearInterval(timeInt);
      }
      let imageUrl =
        isShowCompareImg && compareImgLenth != 1 ? compareImgVal : upImgVal;
      $(".tryAiAlbum-img").attr("src", imageUrl);
      // 使用 fetch 获取图片数据
      let response = await fetch(imageUrl);
      const blob = await response.blob();

      // 创建一个临时 URL 供下载
      const url = URL.createObjectURL(blob);

      // 创建下载链接
      const link = document.createElement("a");
      link.href = url;
      link.download = "image.jpg";

      // 触发点击事件来下载图片
      document.body.appendChild(link);
      link.click();
      // 移除临时链接
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      if (!isShowCompareImg || (isShowCompareImg && compareImgLenth == 1)) {
        if (dataImgWidth / dataImgHeight > 290 / 364) {
          $(".tryAiAlbum .tryAiAlbum-img").addClass("tryAiAlbum-img--height");
        } else {
          $(".tryAiAlbum .tryAiAlbum-img").removeClass(
            "tryAiAlbum-img--height"
          );
        }
      } else {
        if (isShowCompareImg && compareImgLenth == 2) {
          $(".tryAiAlbum .tryAiAlbum-con").addClass("tryAiAlbum-con--two");
        } else {
          $(".tryAiAlbum .tryAiAlbum-con").removeClass("tryAiAlbum-con--two");
        }
        if (
          isShowCompareImg &&
          (compareImgLenth == 3 || compareImgLenth == 4) &&
          document.getElementsByClassName("aiBox")[0]?.offsetWidth /
            document.getElementsByClassName("aiBox")[0]?.offsetHeight >
            1
        ) {
          $(".tryAiAlbum .tryAiAlbum-con").addClass("tryAiAlbum-con--width");
        } else {
          $(".tryAiAlbum .tryAiAlbum-con").removeClass("tryAiAlbum-con--width");
        }
      }
      openPop(".tryAiAlbum", "popUp::Share::view");
    }, 2000);

    // this.dleCustomEvent("aiTryOn_icon", "AiTryOn_save", "click");
    // this.dleCustomEventN("popUp", "popUp::AiTryOn_SharePhotos::view", "popUp");
  });
}
// 关闭按钮
function closePop(el, parentEl, callback, event_el) {
  $(el).on("click", function (event) {
    if ($(parentEl + " .pop_main").hasClass("pop_main--bottom")) {
      $(parentEl + " .pop_main").removeClass("active");
    }
    $(parentEl + " .pop_main").fadeOut();

    scheduleTask(function () {
      $(parentEl + " .window-cover").fadeOut();
    });
    if (callback) {
      callback();
    }
    if (
      event.target?.className?.indexOf("window-cover_con-close") > -1 &&
      event_el
    ) {
      window.dleCustomEvent("popUp", event_el, "popUp_Click", "ai-try-on");
    }
    return false;
  });
}
// 弹出弹窗
function openPop(el, event_el) {
  $(el + " .window-cover").fadeIn();
  $(el + " .pop_con").css("opacity", 1);
  if ($(el + " .pop_main").hasClass("pop_main--bottom")) {
    $(el + " .pop_main").addClass("active");
  }
  $(el + " .pop_main").fadeIn();
  if (event_el) {
    window.dleCustomEvent("popUp", event_el, "popUp", "ai-try-on");
  }
}

// 点击分享按钮
function sharePage() {
  $(".share_popup .window-cover").show();
  $(".share_popup .pop_main").show();
  $(".share_popup .pop_con").css("opacity", 1);
  window?.dleCustomEvent("popUp", "popUp::Share::view", "popUp", "ai-try-on");
}
// 授权接口
function authorization() {
  if (window?.customerData?.email || !tryOnData?.loginPopupEnabled) {
    let uuidVal = window.getAuthorization() || window.ShopifyCustomerInfo?.uuid || "";
    console.log("接口02", authorization);
    try {
      $.ajax({
        url: window.API_BASE + "/api/klaiyi/try_on/authorization",
        type: "POST",
        headers: {
          Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          customer_id: window?.customerData?.email
            ? window.customerData.id
            : getLocalStorage("uuid") || uuidVal,
        }), // 核心：将 JS 对象转为 JSON 字符串
        dataType: "json",

        success: function (res) {
          if (res.code === 200000) {
            wsInit();
            scheduleTask(() => {
              setLocalStorage(
                "authorizeResult",
                "authorizeResult",
                24 * 30 * 12 * 10
              );
              $(".tryOnDialog .pop_main").removeClass("active");
              $(".tryOnDialog .window-cover").fadeOut();
              $(".tryOnDialog .pop_main").fadeOut();
              $(".upPhone-cover").addClass("hide");
            });
          }
        },
      });
    } catch (error) {}
  }
}
// 授权弹窗
function comfirmTryOnDialog() {
  $(".tryOnDialog-try")
    .off("click")
    .on("click", function () {
      authorization();
      window.dleCustomEvent(
        "popUp",
        "popUp::Wig try on::Try now",
        "popUp_Click",
        "ai-try-on"
      );
    });
}
// 对比图放大
function initCampaignBanner(item, index) {
  $(".tryOn-full .swiper-wrapper").html("");
  compareImgData.forEach(function (compaidEle, compareIndex) {
    if (compaidEle?.image) {
      $(".tryOn-full .swiper-wrapper").append(
        "<div class='swiper-slide'> <img class='aiBox-top_banner tryOn-full_banner'  src= '" +
          compaidEle?.image +
          "'  alt='banner'</div>"
      );
    }
  });
  $(".tryOn-full").fadeIn();
  scheduleTask(() => {
    campaignBanner = destroySwiperInstance(campaignBanner);
    if (
      typeof Swiper !== "function" ||
      !document.querySelector(".tryOn-full_con")
    ) {
      return;
    }
    campaignBanner = new Swiper(".tryOn-full_con", {
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesVisibility: true,
      observer: true,
      observerParents: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
    });
    if (campaignBanner && !campaignBanner.destroyed) {
      campaignBanner.update();
      safeSwiperSlideTo(campaignBanner, Math.max(0, index - 1), 0);
    }
  });
}
function reviewStarClick() {
  $(".aiReview .star-icon").on("click", function () {
    starnum = $(this).data("index");
    $("._4-star").html(starnum + "star");
    $(".aiReview .star-icon").each(function (index, event) {
      if (index + 1 <= starnum) {
        $(".aiReview .star-icon")
          .eq(index)
          .addClass("icon-Star_Level_fill")
          .removeClass("icon-Star_Level");
      } else {
        $(".aiReview .star-icon")
          .eq(index)
          .addClass("icon-Star_Level")
          .removeClass("icon-Star_Level_fill");
      }
    });
  });
}
function reviewShapeClick() {
  $(".aiReview-checkbox-item.shape").on("click", function () {
    if ($(this).hasClass("active")) {
      return false;
    } else {
      $(".aiReview-checkbox-item.shape.active").removeClass("active");
      $(this).addClass("active");
    }
    if ($(this).attr("data-key") == 7 && $(this).hasClass("active")) {
      $(".aiReview-checkbox-input").removeClass("hide");
    } else {
      $(".aiReview-checkbox-input").addClass("hide");
    }
  });
}
function reviewTarea() {
  $(".aiReview-textarea").on("change", function () {
    reviewTextarea = $(this).val();
    if (reviewTextarea?.length > 1000) {
      reviewTextarea = reviewTextarea?.slice(0, 1000);
      return;
    }
    $("._0-1000").text(reviewTextarea?.length + "/1000");
  });
}
// 提交评论
function sumbitReview() {
  $(".aiReview-submit").on("click", function () {
    $(".aiReview-checkbox-item.shape.active").each(function () {
      if ($(this).attr("data-key") == 7) {
        checkedData = $(".form-list_item--input").val();
      } else {
        checkedData = $(this).text();
      }
    });
    let commentTagVal = "";
    let uuidVal = "";
    if (!window.customerData?.email && !getLocalStorage("uuid")) {
      uuidVal = window.ShopifyCustomerInfo?.uuid;
      setLocalStorage("uuid", uuidVal, 24 * 30 * 6);
    }
    $(".aiReview-checkbox-item--tags.active").each(function () {
      commentTagVal = commentTagVal + $(this).attr("data-value") + ",";
    });
    let ages = "";
    $(".aiReview-checkbox-item.age.active").each(function () {
      ages = $(this).attr("data-key");
    });
    $.ajax({
      url: window.API_BASE + "/api/klaiyi/try_on/comment",
      type: "POST",
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
      },
      data: {
        star: starnum,
        tags: commentTagVal?.replace(/,$/, ""),
        content: reviewTextarea,
        image: compareImgVal ? compareImgVal : upImgVal,
        style_id: recommendPro?.name
          ? recommendPro?.name
          : lastTryOnInfo?.style_id,
        age: ages,
        occupation: checkedData,
        email: window?.customerData?.email,
        customer_id:
          window?.customerData?.id || getLocalStorage("uuid") || uuidVal,
      },
      dataType: "json",
      success: function (res) {
        if (res.code === 200000) {
          $(".aiReview .pop_main").fadeOut();
          $(".aiReview .pop_main").removeClass("active");
          $(".aiReview .window-cover").fadeOut();
        }
      },
    });
    window.dleCustomEvent(
      "popUp",
      "popUp::AiTryOn_Review",
      "popUp_Click",
      "ai-try-on"
    );
  });
  // console.log(checkedData?.replace(/,$/, ""));
}
function generateToken(userId, secretKey) {
  // 1. 生成基础信息
  const timestamp = Date.now().toString(); // 时间戳（防止重复）
  const nonce = Math.random().toString(36).substring(2, 10); // 随机字符串（增加唯一性）

  // 2. 拼接待加密的原始数据（格式可自定义，需前后端一致）
  const rawData = `userId=${userId}&timestamp=${timestamp}&nonce=${nonce}`;

  // 3. 使用 HMAC-SHA256 算法加密（密钥为 secretKey）
  const signature = CryptoJS.HmacSHA256(rawData, secretKey).toString(
    CryptoJS.enc.Hex
  );

  // 4. 组合成最终 Token（格式：原始数据 + 加密签名，用分隔符区分）
  const token = `${rawData}&signature=${signature}`;

  return token;
}
function coverLogin(data) {
  if (
    (!loginPopupEnabled && !popupEnabled) ||
    (loginPopupEnabled && isLogin && !popupEnabled) ||
    (popupEnabled && isAuthorized && !loginPopupEnabled) ||
    (loginPopupEnabled && isLogin && popupEnabled && isAuthorized)
  ) {
    $(".upPhone-cover").addClass("hide");
    if (
      !isAuthorized &&
      getLocalStorage("authorizeResult") == "authorizeResult" &&
      loginPopupEnabled
    ) {
      return false;
    }
    wsInit();
  }
}
//ws init
function wsInit() {
  if (isWsInit) {
    return false;
  }
  let uuidVal = "";
  if (!window.customerData?.email && !getLocalStorage("uuid")) {
    uuidVal = window.ShopifyCustomerInfo?.uuid;
    setLocalStorage("uuid", uuidVal, 24 * 30 * 6);
  }
  ws = new WebSocket(
    window.API_BASE +
      "/websocket/tryon/" +
      "?token=" +
      getLocalStorage("uuid") || uuidVal
  );
  if (ws) {
    this.isWsInit = true;
  }

  // 服务端主动推送消息时会触发这里的onmessage
  ws.onmessage = async function (e) {
    // json数据转换成js对象
    var datas = eval("(" + e.data + ")");
    var type = datas.type || "";
    switch (type) {
      // Events.php中返回的init类型的消息，将client_id发给后台进行uid绑定
      case "init":
        // 利用jquery发起ajax请求，将client_id发给后端进行uid绑定
        if (!tryToken) {
          try {
            $.ajax({
              url: window.API_BASE + "/api/klaiyi/try_on/bind-client",
              type: "POST",
              headers: {
                Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
                "Content-Type": "application/json",
              },
              data: JSON.stringify({
                customer_id: isLogin
                  ? window.customerData?.id
                  : getLocalStorage("uuid") || uuidVal,
                client_id: datas.client_id,
                is_guest: window.customerData?.id ? false : true,
                email: window.customerData?.email,
              }),
              dataType: "json",
              success: function (res) {
                if (res?.code == 200000) {
                  tryToken = res?.data?.token;
                } else if (res?.code === 200102) {
                  // 登录未授权
                  try {
                    authorization();
                  } catch (error) {
                    throw new Error("授权接口请求报错" + error);
                  }
                }
              },
            });
          } catch (error) {
            throw new Error("ws init请求失败:" + error);
          }
        }

        break;
      case "bind_client_error":
        tryOnImgCall("bind_client_error", datas);
        break;
      //detect_image_task_success 代表检测任务创建成功，不代表检测成功
      /* {"type":"detect_image_task_success","data":{"status":true,"message":"Detection task call success"}}*/
      case "detect_image_task_success":
        break;
      //detect_image_task_fail 代表检测任务创建失败
      /* {"type":"detect_image_task_fail","data":{"status":false,"message":"Detection task call fail"}}*/
      case "detect_image_task_fail":
        tryOnImgCall("detect_image_task_fail", datas);
        break;
      // 检测超时主动通知
      case "try_on_check_call_timeout_wait":
        tryOnImgCall("try_on_check_call_timeout_wait", datas);
        break;

      //detect_image_success:代表图片检测成功
      //{"type":"detect_image_success","data":{"status":true,"message":"Detected image successfully"}}
      case "detect_image_success":
        tryOnImgCall("detect_image_success", datas);
        break;
      //detect_image_fail代表图片检测失败
      //{"type":"detect_image_fail","data":{"status":false,"message":"Detected image failed"}}
      case "detect_image_fail":
        tryOnImgCall("detect_image_fail", datas);
        break;
      //try_on_call_success 代表试戴任务创建成功，不代表成功
      //{"type":"try_on_call_success","data":{"status":true,"message":"try on task call success"}}
      case "try_on_call_success":
        tryOnModuleCall("try_on_call_success", datas);
        break;
      //try_on_call_fail 代表试戴任务创建失败
      //{"type":"try_on_call_fail","data":{"status":false,"message":"error message"}}
      case "try_on_call_fail":
        tryOnModuleCall("try_on_call_fail", datas);
        break;

      // {"type":"try_on_fail","data":{"status":false,"message":"error message"}}
      case "try_on_fail":
        tryOnModuleCall("try_on_fail", datas);
        break;
      //try_on_verify_fail//{"type":"try_on_verify_fail","data":{"status":false,"message":"无效token"}}
      case "try_on_verify_fail":
        tryOnModuleCall("try_on_verify_fail", datas);
        break;
      //  试戴超时主动通知
      case "try_on_call_timeout_wait":
        tryOnModuleCall("try_on_call_timeout_wait", datas);
        break;
      //try_on_insufficient// {"type":"try_on_verify_fail","data":{"status":false,"message":"试戴次数不足"}}
      case "try_on_insufficient":
        tryOnModuleCall("try_on_insufficient", datas);
        break;
      //try_on_authorization// {"type":"try_on_authorization","data":{"status":false,"message":"未授权"}}
      case "try_on_authorization":
        tryOnModuleCall("try_on_authorization", datas);
        break;
      //try_on_success 试戴成功
      //{"type":"try_on_success","data":{"status":true,"image":"试戴结果","try_on_number":1//剩余可试戴数量}}
      case "try_on_success":
        tryOnModuleCall("try_on_success", datas);
        break;
      default:
      // console.log(e.data);
    }
  };
  ws.onerror = function () {
    errorLinkNumber--;
    ws = null;
    isWsInit = false;
  };
  ws.onclose = function () {
    errorLinkNumber--;
    ws = null;
    isWsInit = false;
  };
}
// 图片监测回调
function tryOnImgCall(data, val) {
  if (data == "detect_image_success") {
    upImgVal = null;
    if (photoURL) {
      photoURLCopy = JSON.parse(JSON.stringify(photoURL));
    }
    // 图片监测成功
    isShowAbility = true;
    //this.BannerSwiper?.autoplay?.stop();
    isShowPhoneBtn = false;
    swiperRealIndex = null;
    $(".tryAi-loading").hide();
    isValidataImg = true;
    if (isShowAbility || isValidataImg) {
      $(".ability").removeClass("hide");
      $(".upPhone").addClass("upPhone--hide");
    }

    showHomeContent();
    dataImgWidth = dataImgWidthOriginal;
    dataImgHeight = dataImgHeightOriginal;
    imgRadio();

    scheduleTask(function () {
      dleCustomEvent(
        "aiTryOn_icon",
        "AiTryOn_picturesUploaded",
        "click",
        "ai-try-on"
      );
      shakeModule();
      thumbStatus = true;
      if (fileChangeStartSource == "uploads") {
        toast({
          type: "success",
          content: `generated successfully,
${val?.data?.customer_try_on_number} try-on opportunities remain`,
          iconUseTag: "i",
        });
      }
      // 对比图更新
      updataCompareImg();
      if (
        BannerSwiper &&
        !BannerSwiper.destroyed &&
        BannerSwiper.params &&
        !BannerSwiper.autoplay?.running
      ) {
        let initThubIndex = BannerSwiper.realIndex;
        swiperRealIndex = BannerSwiper.realIndex;
        let originalTabModule = styleModel[initThubIndex];
        tryOnModule(originalTabModule, initThubIndex);
      }
      if (
        BannerSwiper &&
        !BannerSwiper.destroyed &&
        BannerSwiper.autoplay &&
        typeof BannerSwiper.autoplay.stop === "function"
      ) {
        try {
          BannerSwiper.autoplay.stop();
        } catch (err) {}
      }
    });
  } else {
    if (data == "detect_image_fail") {
      tryOnResult = val;
      let showBtn =
        fileChangeStartSource == "upload" || fileChangeStartSource == "video";
      // 图片监测失败
      isShowPhoneBtn = isClickCapture ? true : showBtn;
      let srcVal =
        photoURL?.indexOf("https://cdn.aistyle.me") > -1 ||
        photoURL?.indexOf("klaiyihair.com") > -1
          ? photoURL
          : "https://ima.klaiyihair.com/" + photoURL;
      $(".tryAiFail-img_val").attr("src", srcVal);
      $(".tryAiFail-tit span").text(tryOnResult?.data?.message);
      openPop(".tryAiFail");
      $(".tryAi-loading").hide();
      thumbStatus = true;
      showHomeContent();
    } else if (data == "detect_image_task_fail") {
      $(".tryAi-loading").hide();
      isShowPhoneBtn = isClickCapture
        ? true
        : fileChangeStartSource == "upload" || fileChangeStartSource == "video"
        ? true
        : false;
      isShowVideo = false;
      toast(val?.data?.message);
      thumbStatus = true;
      showHomeContent();
    } else if (data == "try_on_check_call_timeout_wait") {
      toast(val?.data?.message);
      $(".tryAi-loading").hide();
      thumbStatus = true;
      isShowPhoneBtn = isClickCapture
        ? true
        : fileChangeStartSource == "upload" || fileChangeStartSource == "video"
        ? true
        : false;
      showHomeContent();
    } else if (data == "bind_client_error") {
      toast(val?.data?.message);
      $(".tryAi-loading").hide();
      thumbStatus = true;
      // this.isShowPhoneBtn = this.isClickCapture ? true : false;
      isWsInit = false;
      tryToken = null;
      ws.close();
      wsInit();
    }
  }
  // }
}
// 试戴模型监测回调
function tryOnModuleCall(data, val) {
  // if (!this.isMoudueTimeOut) {
  // clearTimeout(this.moudueTimeOutVal);
  //未超时
  if (data == "try_on_success") {
    // 模型检测成功
    // 此处的图片单独存储  为清除模型做准备
    upImgVal = val?.data?.image;
    shareLink = val?.data?.share_link;
    // 缓存试戴结果，同图同模型再次切换可秒开
    if (recommendPro?.name && val?.data?.image) {
      tryOnResultCache[getTryOnCacheKey(recommendPro.name)] = {
        image: val.data.image,
        width: val.data.width,
        height: val.data.height,
        share_link: val.data.share_link,
      };
    }
    // this.isShowAbility = true;
    $(".ability").removeClass("hide");
    customerTryOnNumber = val?.data?.try_on_number;
    isValidataImg = true;
    thumbStatus = true;
    swiperRealIndex = swiperIndex;
    dataImgWidth = val?.data?.width;
    dataImgHeight = val?.data?.height;
    imgRadio();

    // 对比状态
    updataCompareImg();
    showHomeContent();
    $(".tryAi-loading").hide();
    scheduleTask(() => {
      window.dleCustomEvent(
        "aiTryOn_icon",
        "AiTryOn_tryOnSuccess",
        "click",
        "ai-try-on"
      );
      isShowCoupon = val?.data?.is_show_coupon;
      showCoupon();
      productItem = recommendPro?.product;
      console.log("试戴02", productItem);
      window.klaiyiDlPush({
        event: "dle_view_item_list",
        dlv_ec: "ai-try-on",
        dlv_ea: `productView`,
        dlv_el: "ai-try-on_productList",
        dlv_en: "view_item_list",
        ecommerce: {
          items: [
            {
              item_name: productItem?.title,
              item_id: productItem?.product_id,
              price: productItem?.price_new,
              item_category:
                productItem?.categories && productItem?.categories?.length > 0
                  ? productItem.categories[0]?.id
                  : 0,
              item_list_name: "ai-try-on_productList",
              index: 1,
              quantity: 1,
              currency: "$",
            },
          ],
        },
      });
    });
  } else {
    if (data == "try_on_fail" || data == "try_on_call_fail") {
      $(".tryAi-loading").hide();
      thumbStatus = true;
      // 试戴失败
      toast(val?.data?.message);
    } else if (data == "try_on_verify_fail") {
      // 无效token 无效链接
      isShowUpLoading = false;
      $(".tryAi-loading").hide();
      thumbStatus = true;
      showHomeContent();
      toast(val?.data?.message);
      isWsInit = false;
      tryToken = null;
      // this.ws.onmessage = null;
      ws.close();
      wsInit();
    } else if (data == "try_on_insufficient") {
      isShowUpLoading = false;
      $(".tryAi-loading").hide();
      thumbStatus = true;
      // let now = this.$dayjs().tz("America/Los_Angeles");
      // let tomorrow = now.add(1, "day").startOf("day");
      window.setLocalStorage(
        "lastZeroModule",
        {
          id: window.customerData.id,
          imageOriginalName: imageOriginalName,
          sourceImage: photoURLCopy,
          lastSuccessImage: upImgVal,
          styleId: recommendPro?.name,
        },
        24
      );
      // 试戴次数不足
      if (appDownLoadLinkEnabled) {
        $(".tryAiApp-con").attr(
          "src",
          window.API_BASE + "/uploads/" + tryOnData?.app_download
        );
        openPop(".tryAiApp", "popUp::AiTryOn_FreeTriesUsedUp::view");
        $(".tryAiApp-con").on("click", function () {
          window.dleCustomEvent(
            "popUp",
            "popUp::AiTryOn_FreeTriesUsedUp::link",
            "popUp_Click",
            "ai-try-on"
          );
        });
      } else {
        toast(
          "Your opportunity has been exhausted. Please contact customer service or come again tomorrow."
        );
      }
    } else if (data == "try_on_authorization") {
      // 未授权
      $(".tryAi-loading").hide();
      thumbStatus = true;
      openPop(".tryOnDialog");
      toast(val?.data?.message);
    } else if (data == "try_on_call_timeout_wait") {
      // 试戴超时
      $(".tryAi-loading").hide();
      thumbStatus = true;
      shareLink = val?.data?.task_link;
      // this.$refs.tryAiSlowly.changeDialog();
      $(".tryAiSlowly-link").text(shareLink);
      openPop(".tryAiSlowly");
    }
  }
  // }
}
// 更新对比图
function updataCompareImg() {
  if (isShowCompareImg) {
    let imgLength = 0;
    let isChange = false;
    compareImgData.forEach((item, index) => {
      if (isChange) {
        return false;
      }
      if (!item?.image || item?.isOriginalImg) {
        compareImgData[index].image = upImgVal || photoURLCopy;
        if (upImgVal) {
          if (item?.isOriginalImg) {
            compareImgData[index].isOriginalImg = false;
          }
        } else {
          compareImgData[index].isOriginalImg = true;
        }
        compareImgData[index].width = JSON.parse(JSON.stringify(dataImgWidth));
        compareImgData[index].height = JSON.parse(
          JSON.stringify(dataImgHeight)
        );

        isChange = true;
        return false;
      } else {
        imgLength++;
      }
    });
    if (imgLength == 4) {
      let compareImg = JSON.parse(JSON.stringify(compareImgData));
      compareImg = compareImg.slice(1);
      compareImgData = [
        ...compareImg,
        {
          image: upImgVal,
          width: JSON.parse(JSON.stringify(dataImgWidth)),
          height: JSON.parse(JSON.stringify(dataImgHeight)),
          text: "",
          isOriginalImg: false,
        },
      ];
    }
    // 修改对比图dom
    compareImgData.forEach(function (value, indexs) {
      if (value?.image) {
        $(".aiBox-compare .aiBox-compare-item")
          .eq(indexs)
          .find("img")
          .attr("src", value?.image);
        $(".aiBox-compare .aiBox-compare-item")
          .eq(indexs)
          .find(".aiBox-compare-close")
          .show();
        if (
          value?.width &&
          value?.height &&
          value?.width / value?.height > 194 / (boxImgHeight / 2)
        ) {
          $(".aiBox-compare .aiBox-compare-item")
            .eq(indexs)
            .find("img")
            .addClass("aiBox-compare-item-img--width")
            .removeClass("aiBox-compare-item-img--height");
        } else {
          $(".aiBox-compare .aiBox-compare-item")
            .eq(indexs)
            .find("img")
            .addClass("aiBox-compare-item-img--height")
            .removeClass("aiBox-compare-item-img--width");
        }
      }
    });
  }
}
function timeSecondDown() {
  timeInt = setInterval(() => {
    timeSecond--;
    if (timeSecond == 0) {
      clearInterval(this.timeInt);
      this.timeSecond = 10;
    }
  }, 1000);
}
/**
 * @Date: 2024-09-27 17:10:44
 * @Description: 试戴模型和图片匹配
 * @return {*}
 */
async function tryOnModule(item, index) {
  console.log("获取试戴内容", item);
  // 试戴次数用完
  let lastZeroModule = getLocalStorage("lastZeroModule");
  if (
    customerTryOnNumber == 0 &&
    lastZeroModule &&
    item?.name == lastZeroModule?.name &&
    imageOriginalName == lastZeroModule?.imageOriginalName
  ) {
    if (appDownLoadLinkEnabled) {
      openPop(".tryOnPop", "popUp::Share::view");
    } else {
      toast(
        "Your opportunity has been exhausted. Please contact customer service or come again tomorrow."
      );
    }
    window.dleCustomEvent(
      "aiTryOn_icon",
      "AiTryOn_Model::" + index,
      "click",
      "ai-try-on"
    );

    return false;
  }
  if (!photoURLCopy) {
    return false;
  }
  window.dleCustomEvent(
    "aiTryOn_icon",
    "AiTryOn_Model::" + index,
    "click",
    "ai-try-on"
  );
  if (!isLogin && loginPopupEnabled) {
    // this.$refs?.LoginPopup?.changeDialog();
    return false;
  }

  if (!tryToken) {
    // token未生成 请稍后再试
    $(".tryAi-loading").hide();
    toast("Establishing Data Link... ");
    return false;
  }

  // 命中缓存：同步换图，避免再次等待 AI
  var cached = tryOnResultCache[getTryOnCacheKey(item?.name)];
  if (cached && cached.image) {
    applyCachedTryOnResult(cached, item, index);
    return true;
  }

  $(".tryAi-loading").show();

  timeSecond = 10;
  timeSecondDown();
  thumbStatus = false;
  swiperIndex = index;
  recommendPro = item;
  scheduleTask(function () {
    try {
      ws?.send(
        JSON.stringify({
          type: "try_on",
          url:
            photoURLCopy?.indexOf("https://cdn.aistyle.me") > -1 ||
            photoURLCopy?.indexOf(".klaiyihair.com") > -1
              ? photoURLCopy
              : "https://ima.klaiyihair.com/" + photoURLCopy,
          style_id: item?.name, //非必传没选就不传
          token: tryToken,
          image_original_name: imageOriginalName,
        })
      );
    } catch (error) {
      // this.$apm?.captureError("试戴模型 + t图片监测回调" + error);
    }
  });
}
// 操作后当前应该显示的内容
function showHomeContent() {
  if (isShowPhoneBtn) {
    $(".upPhone").show();
  } else {
    $(".upPhone").hide();
  }
  if (!isShowVideo) {
    $(".aiBox-capture").addClass("aiBox-capture--hide");
    if (!isValidataImg) {
      $(".banner").removeClass("banner--hide");
    } else {
      if (!$(".banner").hasClass("banner--hide")) {
        $(".banner").addClass("banner--hide");
      }
      $(".ability").removeClass("hide");
      let srcVal = null;
      if (upImgVal) {
        srcVal = upImgVal;
      } else {
        srcVal = photoURLCopy ? photoURLCopy : photoURL;
      }
      homeImgSrc =
        srcVal?.indexOf("https://cdn.aistyle.me") > -1 ||
        srcVal?.indexOf("klaiyihair.com") > -1
          ? srcVal
          : "https://ima.klaiyihair.com/" + srcVal;

      $(".aiBox-top_banner--only").attr("src", homeImgSrc);
      $(".aiBox-top_banner--only").removeClass("hide");
      if (recommendPro) {
        console.log("获取试戴产品信息02", recommendPro);
        $(".recommendPro").attr("href", recommendPro?.product?.url);
        $(".recommendPro-img").attr(
          "src",
          recommendPro?.product?.featured_image
        );

        $(".recommendPro").removeClass("hide");
        // ga
        $(".recommendPro")
          .off("click")
          .on("click", function (event) {
            console.log("试戴成功的点击1", recommendPro.product?.product_id);
            let eleName =
              event.target?.className?.indexOf("icon-Shopping-bag") > -1
                ? "productClick_txt"
                : "productClick_img";
            window.klaiyiDlPush({
              event: "dle_select_item",
              dlv_ec: "ai-try-on",
              dlv_ea: eleName,
              dlv_el: "ai-try-on_productList",
              dlv_en: "select_item",
              ecommerce: {
                items: [
                  {
                    item_name: recommendPro.product?.title,
                    item_id: recommendPro.product?.product_id,
                    price: recommendPro.product?.price_new,
                    item_category:
                      recommendPro.product?.categories &&
                      recommendPro.product?.categories?.length > 0
                        ? recommendPro.product.categories[0]?.id
                        : 0,
                    item_list_name: "ai-try-on_productList",
                    index: 1,
                    quantity: 1,
                    currency: "$",
                  },
                ],
              },
            });
          });
      }
    }
  }
}
// 拍照
function capture() {
  $(".upPhone-phone").on("click", async function () {
    isShowPhoneBtn = false;
    $(".banner").addClass("banner--hide");
    $(".upPhone").addClass("upPhone--hide");
    $(".upPhone").hide();
    $(".aiBox-capture").removeClass("aiBox-capture--hide");
    isShowVideo = true;
    await startVideo();
    initVideo();
    window.dleCustomEvent(
      "aiTryOn_icon",
      "AiTryOn_Take a Photo",
      "click",
      "ai-try-on"
    );
  });
}
function initReviewPop(name) {
  commentPopTag?.forEach(function (values, indexs) {
    $(".aiReview-checkbox--tags").append(
      "<div class='aiReview-checkbox-item aiReview-checkbox-item--tags' data-value='" +
        values +
        "'><div class='matched-my-face-shape'>" +
        values +
        "</div></div"
    );
  });
  // 多选
  $(".aiReview-checkbox-item--tags").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
  });
  $(".aiReview-checkbox-item.age").on("click", function () {
    if ($(this).hasClass("active")) {
      return false;
    }
    $(".aiReview-checkbox-item.age.active").each(function () {
      $(this).removeClass("active");
    });
    $(this).addClass("active");
  });
  reviewStarClick();
  reviewShapeClick();
  reviewTarea();
  sumbitReview(name);

  scheduleTask(function () {
    let uuidVal = "";
    if (!window.customerData?.email && !getLocalStorage("uuid")) {
      uuidVal = window.ShopifyCustomerInfo?.uuid;
      setLocalStorage("uuid", uuidVal, 24 * 30 * 6);
    }
    $.ajax({
      url: window.API_BASE + "/api/klaiyi/try_on/share",
      type: "POST",
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
      },
      data: {
        style_id: recommendPro?.name
          ? recommendPro?.name
          : lastTryOnInfo?.style_id,
        image: compareImgVal ? compareImgVal : upImgVal,
        platform: name,
        email: window?.customerData?.email,
        customer_id:
          window?.customerData?.id || getLocalStorage("uuid") || uuidVal,
      },
      dataType: "json",
      success: function () {
        window.setLocalStorage("tyrOnShare", "tryOnShare", 24);
      },
    });
  });
}
function showCoupon() {
  if (isShowCoupon && window.getLocalStorage("tryOnCoupon") != "tryOnCoupon") {
    let styleCoupon = tryOnData?.style_coupon;
    let couponPopupImage =
      window.API_BASE + "/uploads/" + tryOnData?.coupon_popup_image;
    $(".tryOnCode-copy-code").text(styleCoupon);
    $(".tryOnCode-copy-img").attr({
      src: couponPopupImage,
      // width: tryOnData?.coupon_popup_image_height,
      // height: tryOnData?.coupon_popup_image_height,
    });
    openPop(".tryOnCode", "popUp::AiTryOn_RepeatedUsage::view");
    closePop(
      ".tryOnCode, .window-cover_con-close",
      ".tryOnCode",
      function () {},
      "popUp::AiTryOn_RepeatedUsage::close"
    );
    $(".tryOnCode-copy").on("click", function () {
      copyText($(".tryOnCode-copy-code").text());
      toast({
        type: "success",
        content: "Copy Successfully!",
      });
      if (parseInt($(".tryOn-cartNum").text()) != 0) {
        location.href = window.routes.cartUrl;
      }
      window.dleCustomEvent(
        "popUp",
        "popUp::AiTryOn_RepeatedUsage::tryAgain",
        "popUp_Click",
        "ai-try-on"
      );
    });
    window.setLocalStorage("tryOnCoupon", "tryOnCoupon", 24);
  }
}
// 获取rem根字号
function htmlFontSize() {
  // 获取元素
  let element = document.querySelector("html");
  return element.style.fontSize.replace("px", "") - 0;
}
// 屏幕高度
function getScreenHeight() {
  let screenHeight = 0;
  const isVisualViewportSupported = () => {
    return "visualViewport" in window && window.visualViewport;
  };

  if (isVisualViewportSupported()) {
    // 使用visualViewport API
    screenHeight = window.visualViewport.height;
  } else {
    // 回退方案
    screenHeight = window.screen.availHeight;
  }
  return screenHeight - this.htmlFontSize() * 30.2;
}
function imgRadio() {
  let val = 0;
  if (boxImgWidth && dataImgWidth) {
    if (boxImgWidth / boxImgHeight > dataImgWidth / dataImgHeight) {
      val = 1;
    } else {
      val = 2;
    }
  } else {
    val = 0;
  }
  if (val == 1) {
    $(".aiBox-top_banner")
      .addClass("aiBox-top_banner--height")
      .removeClass("aiBox-top_banner--width");
  } else if (val == 2) {
    $(".aiBox-top_banner")
      .addClass("aiBox-top_banner--width")
      .removeClass("aiBox-top_banner--height");
  } else {
    $(".aiBox-top_banner")
      .removeClass("aiBox-top_banner--width")
      .removeClass("aiBox-top_banner--height");
  }
}
$(function () {
  if (window?.customerData?.email) {
    isLogin = true;
  }
  clientBoxHeight = getScreenHeight();
  if (clientBoxHeight) {
    $(".aiBox-top").height(clientBoxHeight + "px");
  }
  window?.addEventListener("load", () => {
    setTimeout(() => {
      clientBoxHeight = getScreenHeight();
      if (clientBoxHeight) {
        $(".aiBox-top").height(clientBoxHeight + "px");
      }
    }, 100);
  });

  tyOnDataInit();
  boxImgHeight = document.getElementsByClassName("aiBox")[0]?.offsetHeight;
  boxImgWidth = document.getElementsByClassName("aiBox")[0]?.offsetWidth;
  //加载完初始化
  // initBanner();
  // Take a Photo点击
  capture();
  //视频反转
  $(".camera-rotate_img").on("click", function () {
    cameraRotate();
  });
  $(".camera-play").on("click", function () {
    takePictures();
  });
  // input file
  handlerFileChange("#upload1", "upload");
  handlerFileChange("#upload2", "video");
  handlerFileChange("#upload3", "uploads");

  $(".aiBox-compare-close").on("click", function (event) {
    const lastChar = $(this).attr("data-index");
    clearCompare(lastChar - 1);
  });
  // 对比按钮点击
  $(".ability-btn--square").on("click", function () {
    imgCampare();
    window.dleCustomEvent(
      "aiTryOn_icon",
      "aiTryOn_try more",
      "click",
      "ai-try-on"
    );
  });
  $(".ability-save").on("click", function () {
    saveAlbum();
    window.dleCustomEvent("aiTryOn_icon", "aiTryOn_save", "click", "ai-try-on");
    // 试戴保存弹窗
  });
  closePop(
    ".tryAiAlbum .window-cover_con-close, .tryAiAlbum .share-item_link",
    ".tryAiAlbum",
    () => {},
    "popUp::Share::close"
  );

  //分享按钮
  closePop(
    ".share_popup .window-cover_con-close, .share_popup,  .share_popup .share_popup-item",
    ".share_popup",
    function () {},
    "popUp::Share::close"
  );
  $(".ability-share").on("click", function () {
    sharePage();
    window.dleCustomEvent(
      "aiTryOn_icon",
      "aiTryOn_share",
      "click",
      "ai-try-on"
    );
  });
  // 失败弹窗
  closePop(".tryAiFail .window-cover_con-close, .tryAiFail-btn", ".tryAiFail");
  // 加载超时
  closePop(
    ".tryAiSlowly .window-cover_con-close, .tryAiSlowlyMore",
    ".tryAiSlowly"
  );
  // 超时 copy
  $(".tryAiSlowlyMore").on("click", function () {
    window.copyText(shareLink);
    toast({
      type: "success",
      content: "Copy Successfully!",
    });
  });
  //   试戴次数用完
  closePop(
    ".tryAiApp .window-cover_con-close",
    ".tryAiApp",
    function () {},
    "popUp::AiTryOn_FreeTriesUsedUp::close"
  );
  // 试戴引导弹窗
  closePop(
    ".tryOnDialog .window-cover_con-close, .tryOnDialog-close",
    ".tryOnDialog"
  );
  $(".tryOnDialog .window-cover_con-close").on("click", function () {
    window.dleCustomEvent(
      "popUp",
      "popUp::Wig try on::No, Thanks",
      "popUp_Click",
      "ai-try-on"
    );
  });

  //对比放大图
  $(".tryOn-full_close").on("click", function () {
    $(".tryOn-full").fadeOut();
  });
  closePop(
    ".aiReview .window-cover_con-close",
    ".aiReview",
    function () {},
    "popUp::AiTryOn_Review::close"
  );
  // code弹窗
  // openPop(".tryOnCode");

  // 点击返回按钮
  $(".tryOn-head-left").on("click", function () {
    if (!$(".aiBox-capture").hasClass("aiBox-capture--hide")) {
      $(".aiBox-capture").addClass("aiBox-capture--hide");
      stopVideo();
      if (!isValidataImg) {
        $(".banner").removeClass("banner--hide");
        $(".upPhone").removeClass("upPhone--hide").show();
      } else {
        $(".aiBox-top_banner--only").attr("src", homeImgSrc);
        $(".aiBox-top_banner--only").removeClass("hide");
      }
      window.dleCustomEvent(
        "camera_icon",
        "Camera_return",
        "click",
        "ai-try-on"
      );
    } else {
      const url = window.location.href; // 获取当前页面 URL
      const params = new URLSearchParams(new URL(url).search); // 解析参数部分
      const proId = params.get("proId"); // 获取 proId 的值
      if (proId) {
        location.href = params.get("proUrl");
      } else {
        location.href = "/";
      }
      window.dleCustomEvent(
        "aiTryOn_icon",
        "AiTryOn_return",
        "click",
        "ai-try-on"
      );
    }
  });
  $(".tryAiAlbum-con .share-item_link").on("click", function () {
    let name = $(this).attr("data-name");
    url = "";
    switch (name) {
      case "tumbler":
        url =
          "https://twitter.com/intent/tweet?app=110&text=" +
          encodeURIComponent(
            "See my latest AI hairstyle! Come try it for yourself!"
          ) +
          "&url=" +
          encodeURIComponent(window.location?.href) +
          "&utm_source=twitter";
        break;
      case "pinterest":
        url =
          "https://www.pinterest.com/pin/create/button/?url=" +
          window.location?.href +
          "?utm_source=Pinterest&utm_medium=referral&utm_campaign=PinterestShare&utm_term=AITryon_share";
        break;
      case "facebook":
        url =
          "https://www.facebook.com/sharer/sharer.php?u= " +
          window.location?.href +
          "?utm_source=Insk&utm_medium=referral&utm_campaign=InsShare&utm_term=AITryon_share&" +
          encodeURIComponent(
            "media=" + compareImgVal ? compareImgVal : upImgVal
          );
        break;
    }
    window.open(url, "_blank");
    window.dleCustomEvent(
      "popUp",
      "popUp::AiTryOn_SharePhotos::" + name,
      "popUp_Click",
      "ai-try-on"
    );
  });
  $(".share_popup-item").on("click", function () {
    let name = $(this).attr("data-name");
    url = "";
    switch (name) {
      case "instagram":
        url =
          "https://www.instagram.com/?u=" +
          encodeURIComponent(window.location?.href);
        break;
      case "tiktok":
        url = "https://www.tiktok.com/@klaiyihair";
        break;
      case "pinterest":
        url =
          "https://www.pinterest.com/pin/create/button/?url=" +
          window.location?.href +
          "?utm_source=Pinterest&utm_medium=referral&utm_campaign=PinterestShare&utm_term=AITryon_share";
        break;
      case "facebook":
        url =
          "https://www.facebook.com/sharer/sharer.php?u= " +
          window.location?.href +
          "?utm_source=Insk&utm_medium=referral&utm_campaign=InsShare&utm_term=AITryon_share&" +
          encodeURIComponent(
            "media=" + compareImgVal ? compareImgVal : upImgVal
          );
        break;
      case "twitter":
        url =
          "https://twitter.com/intent/tweet?app=110&text=" +
          encodeURIComponent(
            "See my latest AI hairstyle! Come try it for yourself!"
          ) +
          "&url=" +
          encodeURIComponent(window.location?.href) +
          "&utm_source=twitter";
        break;

      case "whatsapp":
        url =
          "https://api.whatsapp.com/send?text=See my latest AI hairstyle! Come try it for yourself!" +
          window.location.href +
          "?utm_source=whatsApp&utm_medium=referral&utm_campaign=whatsAppShare&utm_term=AITryon_share";
        break;
      case "email":
        url =
          "mailto:?subject=See my latest AI hairstyle! Come try it for yourself!&body=" +
          window.location.href +
          "utm_source=Messenger&utm_medium=referral&utm_campaign=MessengerShare&utm_term=AITryon_share";
        break;
    }
    if (name != "copy") {
      window.open(url, "_blank");
    } else {
      window.copyText(location.href);
      toast("copy successfully!");
    }
    closePop(".tryOnPop");
    window.dleCustomEvent(
      "popUp",
      "popUp::Share::" + name,
      "popUp_Click",
      "ai-try-on"
    );
  });
  // 点击放大
  $(".aiBox-compare-item").on("click", function (event) {
    if (
      event.target?.className &&
      event.target?.className?.indexOf("aiBox-compare-close") > -1
    ) {
      return false;
    }
    let indexVal = $(this).attr("data-index");
    if (compareImgData[indexVal - 1]?.image) {
      initCampaignBanner(compareImgData[indexVal], indexVal);
    }
  });
  // 评论弹窗弹出
  $(".share-item_link, .share_popup-item").on("click", function () {
    if (window.getLocalStorage("tyrOnShare") != "tryOnShare") {
      let name = $(this).attr("data-name");
      initReviewPop(name);
      openPop(".aiReview", "popUp::AiTryOn_Review::view");
    }
  });
  $(".tryOn-head-right").on("click", function () {
    window?.tidioChatApi.push(["show"]);
    window.dleCustomEvent("aiTryOn_icon", "AiTryOn_home", "click", "ai-try-on");
  });
  //
});
